import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import PhotographerListing from './pages/PhotographerListing';
import PhotographerProfile from './pages/PhotographerProfile';
import ClientDashboard from './pages/ClientDashboard';
import PhotographerDashboard from './pages/PhotographerDashboard';
import AssetVault from './pages/AssetVault';
import BookingFlow from './pages/BookingFlow';
import AdminPanel from './pages/AdminPanel';
import AuthPage from './pages/AuthPage';
import { getStoredUser, isAuthenticated } from './lib/auth';

// Simple client-side route guard: redirects to /auth if there's no token,
// and to the caller's own dashboard if their role doesn't match the route.
function ProtectedRoute({ roles, children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/auth" replace />;
  }
  const user = getStoredUser();
  if (roles && user && !roles.includes(user.role)) {
    const fallback = user.role === 'photographer' ? '/photographer/dashboard' : user.role === 'admin' ? '/admin' : '/client/dashboard';
    return <Navigate to={fallback} replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/photographers" element={<PhotographerListing />} />
        <Route path="/photographer/:id" element={<PhotographerProfile />} />
        <Route
          path="/book/:photographerId"
          element={
            <ProtectedRoute roles={['client']}>
              <BookingFlow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/dashboard"
          element={
            <ProtectedRoute roles={['client']}>
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/photographer/dashboard"
          element={
            <ProtectedRoute roles={['photographer']}>
              <PhotographerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vault/:bookingId?"
          element={
            <ProtectedRoute>
              <AssetVault />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute roles={['admin']}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
